// Script para resaltar automáticamente los precios de Orders en Invoice#show
document.addEventListener('DOMContentLoaded', function() {
  console.log('Iniciando order price highlighter...');
  
  function highlightOrderPrices() {
    // Buscar tabla de orders en Invoice#show
    const orderTable = document.querySelector('invoice-orders-table-panel table');
    
    if (!orderTable) {
      console.log('Tabla de orders no encontrada');
      return;
    }
    
    console.log('Tabla de orders encontrada, procesando...');
    
    // Encontrar el índice de la columna Price
    const headers = orderTable.querySelectorAll('thead th');
    let priceColumnIndex = -1;
    
    headers.forEach((header, index) => {
      const headerText = header.textContent.trim().toLowerCase();
      if (headerText.includes('price') || headerText.includes('precio')) {
        priceColumnIndex = index;
        console.log(`Columna Price encontrada en índice: ${index}`);
      }
    });
    
    if (priceColumnIndex === -1) {
      console.log('Columna Price no encontrada en headers');
      return;
    }
    
    // Aplicar clase de resaltado a todas las celdas de Price
    const bodyRows = orderTable.querySelectorAll('tbody tr');
    let highlightedCount = 0;
    
    bodyRows.forEach(row => {
      const cells = row.querySelectorAll('td');
      if (cells.length > priceColumnIndex) {
        const priceCell = cells[priceColumnIndex];
        const cellText = priceCell.textContent.trim();
        
        // Verificar que la celda contiene un precio (formato $X.XX)
        if (cellText.match(/\$\d+\.?\d*/)) {
          priceCell.classList.add('order-price-highlight');
          highlightedCount++;
          console.log(`Price resaltado: ${cellText}`);
        }
      }
    });
    
    console.log(`Total de precios de orders resaltados: ${highlightedCount}`);
  }
  
  // Ejecutar inmediatamente
  highlightOrderPrices();
  
  // Re-ejecutar después de un breve delay para asegurar que Vue ha renderizado
  setTimeout(highlightOrderPrices, 500);
  setTimeout(highlightOrderPrices, 1500);
  
  // Observer para detectar cambios en el DOM (útil para SPA)
  const observer = new MutationObserver(function(mutations) {
    let shouldHighlight = false;
    
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) { // Element node
            if (node.matches && node.matches('invoice-orders-table-panel')) {
              shouldHighlight = true;
            } else if (node.querySelector && node.querySelector('invoice-orders-table-panel')) {
              shouldHighlight = true;
            }
          }
        });
      }
    });
    
    if (shouldHighlight) {
      console.log('DOM cambió, re-ejecutando order price highlighter...');
      setTimeout(highlightOrderPrices, 100);
    }
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  console.log('Order price highlighter configurado correctamente');
});
